import { get, post } from '@/util/request.js';
import type { Request } from '@fibl/oxs-common';

export type InitParams = {
	pkg: string;
	offergroup: string;
	agr?: string;
	searchFilter: Request.RequestProcess['searchFilter'];
	type: string;
	sortId?: string;
	sortText?: string;
	flags?: string[];
};

export async function initRequest(params: InitParams): Promise<string> {
	let id = await post('oxs/request/init', params);
	return id;
}

export type FillParams = {
	process: string;
	attachments: (
		| {
				id: string;
		  }
		| {
				name: string;
				content: string;
		  }
	)[];
	fieldData: Record<string, unknown>;
	fixedData?: Request.RequestFixedData;
};

export async function fillForm(params: FillParams) {
	return post('oxs/request/fill', params);
}

export async function retractProcess(processId: string) {
	return post('oxs/request/retract', { process: processId });
}

export async function setMemberStatus(
	process: string,
	p: { statusLabel?: string; inProgress?: boolean; editorName?: string },
) {
	return post('oxs/request/setstatus', {
		process,
		...p,
	});
}

export async function deleteRequest(data: { id: string; reason: string }) {
	return post('oxs/request/remove', data);
}

export async function setRetrievedStatus(process: string) {
	return post('oxs/request/setretrievedstatus', { process });
}
